export const specialExpressionTypes = {
  '??': '??',
  '&&': '&&',
  '||': '||',
  'array': 'array',
  'function': 'function',
  'for': 'for',
  'let': 'let',
  'loop': 'loop',
  'object': 'object',
  'recur': 'recur',
  'match': 'match',
  'import': 'import',
  'effect': 'effect',
  'perform': 'perform',
  'parallel': 'parallel',
  'race': 'race',
  'settled': 'settled',
} as const
